import { render, staticRenderFns } from "./StaAll.vue?vue&type=template&id=02cf5296&scoped=true&"
import script from "./StaAll.vue?vue&type=script&lang=js&"
export * from "./StaAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf5296",
  null
  
)

export default component.exports